import axios from 'axios';
import { VEH_API_URL } from 'util/constants';
import { store } from 'redux/store';

import { ExhibitDetails, Vendor } from 'models';

// Response Codes

class VehApi {
  private readonly apiUrl = VEH_API_URL;

  public createChatToken(id: string): Promise<string> {
    const endpoint = '/v1/chat/token';
    return axios.post(this.apiUrl + endpoint, { id: id }).then((res) => {
      return res.data;
    });
  }

  public getVendorUserIds(channelGroupId: string): Promise<string[]> {
    const endpoint = '/v1/chat/channel/user-ids';
    return axios.get(this.apiUrl + endpoint, { params: { chat_channel_group: channelGroupId } }).then((res) => {
      return res.data;
    });
  }

  public getVendors(virtualEventHash: string, exhibitSegment: string): Promise<Array<Vendor>> {
    const endpoint = `/v1/vendors?virtual_event_hash=${virtualEventHash}&segment=${exhibitSegment}`;

    return axios.get(this.apiUrl + endpoint).then((res) => {
      return res.data;
    });
  }

  public getPublishedExhibit(exhibitId: string): Promise<ExhibitDetails> {
    const virtualEventHash = store.getState().widget.cms.settings.virtual_event_hash;
    const endpoint = `/v1/exhibits/published?virtual_event=${virtualEventHash}&exhibit=${exhibitId}`;
    return axios.get(this.apiUrl + endpoint).then((res) => {
      return res.data;
    });
  }
}

export default new VehApi();
